/**
 * Scrollen doorgeven aan de pagina zodra een mini-venster op zijn eind zit.
 *
 * 03-10-2026 (Jordy): op de Chats-pagina (Pro) bleef het scrollen hangen in
 * een paneel (Waiting queue, Unanswered, Private, Spenders…) als de muis er
 * toevallig overheen kwam. Chrome "vergrendelt" een scrollbeweging op het
 * eerste element dat kan scrollen; staat dat element al onderaan, dan gebeurt
 * er niets tot je een nieuwe beweging begint. Hier: kan het element onder de
 * muis niet verder in die richting, dan scrollt het eerstvolgende element
 * erboven dat dat wél kan (meestal de pagina). Binnen een paneel scrollen
 * blijft gewoon werken zolang er nog iets te scrollen is.
 */

function kanScrollen(el: HTMLElement, dy: number): boolean {
  const stijl = getComputedStyle(el)
  if (!/(auto|scroll|overlay)/.test(stijl.overflowY)) return false
  if (el.scrollHeight <= el.clientHeight + 1) return false
  if (dy > 0) return el.scrollTop + el.clientHeight < el.scrollHeight - 1
  return el.scrollTop > 0
}

function scrollbaar(el: HTMLElement): boolean {
  const stijl = getComputedStyle(el)
  return /(auto|scroll|overlay)/.test(stijl.overflowY) && el.scrollHeight > el.clientHeight + 1
}

export function installeerScrollDoorgeven(): () => void {
  const opWiel = (e: WheelEvent) => {
    if (e.ctrlKey || e.defaultPrevented || Math.abs(e.deltaY) < Math.abs(e.deltaX)) return
    let el = e.target instanceof HTMLElement ? e.target : null
    // Het binnenste element dat überhaupt kan scrollen.
    while (el && el !== document.body && !scrollbaar(el)) el = el.parentElement
    if (!el || el === document.body || kanScrollen(el, e.deltaY)) return
    // Dit venster zit op zijn eind: zoek het volgende dat verder kan.
    let ouder = el.parentElement
    while (ouder && ouder !== document.body && !kanScrollen(ouder, e.deltaY)) ouder = ouder.parentElement
    const doel: Element | null = ouder && ouder !== document.body
      ? ouder
      : (document.scrollingElement as HTMLElement | null)
    if (!doel) return
    const pixels = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaMode === 2 ? e.deltaY * window.innerHeight : e.deltaY
    e.preventDefault()
    doel.scrollBy({ top: pixels })
  }
  window.addEventListener('wheel', opWiel, { passive: false })
  return () => window.removeEventListener('wheel', opWiel)
}
